import { LANGUAGES } from './languages';
export { LANGUAGES };

export function getInLanguage(pathname = '', lang = '') {
    if (lang && LANGUAGES[lang]) return LANGUAGES[lang].code;
    return getLanguageFromPath(pathname).code || 'en-US';
}

export const SUPPORTED_LANGS = ['en', 'pt', 'es', 'fr', 'it', 'de', 'nl', 'ru'];

export const LOCALE_MAP = {
    en: 'en_US',
    pt: 'pt_BR',
    es: 'es_ES',
    fr: 'fr_FR',
    it: 'it_IT',
    de: 'de_DE',
    nl: 'nl_NL',
    ru: 'ru_RU'
};

export function getLanguageFromPath(pathname = '') {
    if (!pathname || pathname === '/') {
        return { lang: 'en', code: 'en-US', ogLocale: 'en_US' };
    }
    const cleanPath = pathname.split('?')[0];
    const segments = cleanPath.split('/').filter(Boolean);
    const detectedLang = segments.find(seg => SUPPORTED_LANGS.includes(seg));
    const lang = detectedLang || 'en';
    const langInfo = LANGUAGES[lang] || LANGUAGES['en'];
    return {
        lang: lang,
        code: langInfo.code,
        ogLocale: LOCALE_MAP[lang] || 'en_US'
    };
}

export const LANGUAGE_LABELS = {
    en: 'English',
    pt: 'Português',
    es: 'Español',
    fr: 'Français',
    de: 'Deutsch',
    it: 'Italiano',
    nl: 'Nederlands',
    ru: 'Русский'
};

export const MAIN_TOOLS = [
    { title: 'Stopwatch', path: '', key: 'header.nav.stopwatch' },
    { title: 'Countdown Timer', path: 'countdown-timer', key: 'header.nav.countdown' },
    { title: 'Pomodoro Timer', path: 'pomodoro-timer', key: 'header.nav.pomodoro' },
    { title: 'Bomb Timer', path: 'bomb-timer', key: 'header.nav.bomb' },
    { title: 'Rocket Timer', path: 'rocket-timer', key: 'header.nav.rocket' },
    { title: 'Cat Timer', path: 'cat-timer', key: 'header.nav.cat' },
    { title: 'Christmas Timer', path: 'christmas-timer', key: 'header.nav.christmas' },
    { title: 'New Year Countdown', path: 'countdown-new-year', key: 'header.nav.newYear' },
    { title: 'Monster Race', path: 'monster-race', key: 'header.nav.monsterRace' },
    { title: 'Rocket Race', path: 'rocket-race', key: 'header.nav.rocketRace' },
    { title: 'Running Race', path: 'running-race', key: 'header.nav.runningRace' },
    { title: 'Swimming Race', path: 'swimming-race', key: 'header.nav.swimmingRace' },
    { title: 'Dynamite Timer', path: 'dynamite-timer', key: 'header.nav.dynamite' },
    { title: 'Egg Timer', path: 'egg-timer', key: 'header.nav.egg' },
    { title: 'Candle Timer', path: 'candle-timer', key: 'header.nav.candle' },
    { title: 'Visual Classroom Timer', path: 'visual-timer', key: 'header.nav.visualTimer' },
    { title: 'Bouncy Balls Noise Meter', path: 'bouncy-balls-noise-meter', key: 'header.nav.bouncyBalls' },
    { title: 'Pac-Man Classroom Timer', path: 'pacman-timer', key: 'header.nav.pacman' },
    { title: 'Snail Race', path: 'snail-race', key: 'header.nav.snailRace' },
    { title: 'Duck Race', path: 'duck-race', key: 'header.nav.duckRace' },
    { title: 'Horse Race', path: 'horse-race', key: 'header.nav.horseRace' },
    { title: 'Date Calculator', path: 'date-calculator', key: 'header.nav.dateCalculator' },
    { title: 'Clock', path: 'clock', key: 'header.nav.clock' },
    { title: 'Exam Prep Timer', path: 'exam-timer', key: 'header.exam.all' },
    { title: 'Dino Game', path: 'dino-game', key: 'header.nav.dino' },
    { title: 'Tic Tac Toe', path: 'tic-tac-toe', key: 'header.nav.tictactoe' },
    { title: 'Math Bingo', path: 'math-bingo', key: 'header.nav.mathBingo' },
    { title: 'Adventure Runner', path: 'adventure-runner', key: 'header.nav.adventureRunner' },
    { title: 'Math Wizard RPG', path: 'math-wizard', key: 'header.nav.mathWizard' },
    { title: 'Digital Escape Room', path: 'digital-escape-room', key: 'header.nav.escapeRoom' }
];

export const EXAM_TOOLS = [
    { title: 'All Exam Simulators', path: 'exam-timer', icon: '🎓', country: 'ALL', key: 'header.exam.all' },
    // 🇺🇸 US Standardized Tests
    { title: 'Digital SAT Timer', path: 'sat-timer', icon: '📘', country: 'US', key: 'header.exam.sat' },
    { title: 'ACT Exam Timer', path: 'act-timer', icon: '📗', country: 'US', key: 'header.exam.act' },
    { title: 'LSAT 35m Section Timer', path: 'lsat-timer', icon: '⚖️', country: 'US', key: 'header.exam.lsat' },
    { title: 'MCAT Full Length Timer', path: 'mcat-timer', icon: '🩺', country: 'US', key: 'header.exam.mcat' },
    { title: 'GMAT Focus Timer', path: 'gmat-timer', icon: '📊', country: 'US', key: 'header.exam.gmat' },
    { title: 'GRE General Test Timer', path: 'gre-timer', icon: '📈', country: 'US', key: 'header.exam.gre' },
    { title: 'MBE Bar Exam Timer', path: 'bar-exam-timer', icon: '🏛️', country: 'US', key: 'header.exam.bar' },
    // 🇧🇷 Brasil Tests
    { title: 'ENEM Simulado Timer', path: 'enem-timer', icon: '🇧🇷', country: 'BR', key: 'header.exam.enem' },
    { title: 'Concursos Públicos & OAB', path: 'concursos-timer', icon: '🏛️', country: 'BR', key: 'header.exam.concursos' },
    // ☁️ Global / IT Certifications
    { title: 'AWS Certification Timer', path: 'aws-timer', icon: '☁️', country: 'GLOBAL', key: 'header.exam.aws' }
];

export const POPULAR_TIMER_PRESETS = [
    { label: '1 Min', slug: '1-minute-timer' },
    { label: '2 Min', slug: '2-minutes-timer' },
    { label: '3 Min', slug: '3-minutes-timer' },
    { label: '5 Min', slug: '5-minutes-timer' },
    { label: '10 Min', slug: '10-minutes-timer' },
    { label: '15 Min', slug: '15-minutes-timer' },
    { label: '20 Min', slug: '20-minutes-timer' },
    { label: '25 Min', slug: '25-minutes-timer' },
    { label: '30 Min', slug: '30-minutes-timer' },
    { label: '45 Min', slug: '45-minutes-timer' },
    { label: '1 Hour', slug: '1-hour-timer' },
    { label: '2 Hours', slug: '2-hours-timer' },
    { label: '3 Hours', slug: '3-hours-timer' },
    { label: '10 Sec', slug: '10-seconds-timer' },
    { label: '30 Sec', slug: '30-seconds-timer' }
];

export function getLocalizedUrl(pathname = '/', targetLang = 'en') {
    if (!pathname || pathname === '/') {
        return targetLang === 'en' ? '/' : `/${targetLang}`;
    }

    const segments = pathname.split('?')[0].split('/').filter(Boolean);
    if (segments.length === 0) {
        return targetLang === 'en' ? '/' : `/${targetLang}`;
    }

    // e.g. /pt, /es, /de -> home in targetLang
    if (segments.length === 1 && SUPPORTED_LANGS.includes(segments[0])) {
        return targetLang === 'en' ? '/' : `/${targetLang}`;
    }

    // Static unlocalized pages
    if (['terms', 'privacy', 'blog'].includes(segments[0])) {
        return `/${segments.join('/')}`;
    }

    // Preset route: /countdown-timer/:lang/:preset or /countdown-timer/:preset
    if (segments[0] === 'countdown-timer') {
        if (segments.length === 3 && SUPPORTED_LANGS.includes(segments[1])) {
            return `/countdown-timer/${targetLang}/${segments[2]}`;
        }
        if (segments.length === 2 && segments[1].endsWith('-timer')) {
            return `/countdown-timer/${targetLang}/${segments[1]}`;
        }
    }

    // Standard tool route: /<tool> or /<tool>/:lang
    const tool = segments[0];
    return targetLang === 'en' ? `/${tool}` : `/${tool}/${targetLang}`;
}
